import { registerHandler } from "../handler";

declare const snaptr: any;

let snapInitEmail: string;

function initSnap(email: string) {
  const newEmail = email.toLowerCase();
  if (email && snapInitEmail !== newEmail) {
    snaptr("init", "e030eb4f-d3fd-4c13-9338-9c0a3b6847ad", {
      user_email: newEmail,
    });
    snapInitEmail = newEmail;
  }
}

export default function registerHandlers() {
  registerHandler("lead", ({ email }) => {
    initSnap(email);

    snaptr("track", "SIGN_UP", { value: "healthy-weight" });
  });

  registerHandler("purchase", ({ email, order, plan }) => {
    initSnap(email);

    snaptr("track", "PURCHASE", {
      order_value: order.eltv_13_months,
      currency: plan.currency || "USD",
      transaction_id: order.subscriptionId,
      price: order.eltv_13_months,
    });
  });
}
